import { Grid } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import { elementsIds } from "./page.constant";
import { PageGrid } from "./styles";

/**
 * @deprecated
 */
export const PageWrapper = forwardRef(function PageWrapper(
  { id, children, Footer, onScroll, noPadding, overflowHidden, ...props },
  ref
) {
  const [footerHeight, setFooterHeight] = useState(0);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const footerEl = document.getElementById(elementsIds.FOOTER);
    const headerEl = document.getElementById(elementsIds.HEADER);
    if (footerEl) {
      setFooterHeight(footerEl.offsetHeight);
    }
    if (headerEl) {
      setHeaderHeight(headerEl.offsetHeight);
    }
  }, []);

  return (
    <PageGrid
      id={id || "page-wrapper"}
      container
      footerHeight={footerHeight}
      headerHeight={headerHeight}
      noPadding={noPadding}
      onScroll={onScroll}
      overflowHidden={overflowHidden}
      ref={ref}
    >
      <Grid container>
        {children}
      </Grid>
      {Footer && <Footer />}
    </PageGrid>
  );
});
